export default __webpack_public_path__ + "static/media/view-grid.41fab387.svg";